export class ListBySourceModel{
    source: string;
    username: string = '';
    isLoggedInUserAdmin: string = '';
}